import { useContext } from 'react';

import { CostCenterContext } from '../contexts/CostCenterContext';

export default () => useContext(CostCenterContext);
